import * as i0 from "@angular/core";
var ViewSummaryItem = /** @class */ (function () {
    function ViewSummaryItem() {
    }
    return ViewSummaryItem;
}());
export { ViewSummaryItem };
var View = /** @class */ (function () {
    function View() {
    }
    View.ngInjectableDef = i0.defineInjectable({ factory: function View_Factory() { return new View(); }, token: View, providedIn: "root" });
    return View;
}());
export { View };
var DocumentOutline = /** @class */ (function () {
    function DocumentOutline() {
    }
    return DocumentOutline;
}());
export { DocumentOutline };
